import {
  getInterestOptions
} from "./chunk-MAFZ4IXM.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/hooks/wbk/favorites/interests.ts
import { useInfiniteQuery } from "@tanstack/react-query";
var useGetInterestOptions = (props) => {
  return useInfiniteQuery({
    queryKey: ["getInterestOptions", props],
    queryFn: ({ pageParam = 1 }) => {
      return getInterestOptions(__spreadProps(__spreadValues({}, props), { page: pageParam }));
    },
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      const { current_page, per_page } = lastPage;
      const total_pages = Math.ceil(lastPage.total / per_page);
      return current_page < total_pages ? lastPageParam + 1 : void 0;
    },
    initialPageParam: 1,
    enabled: false,
    staleTime: Infinity
  });
};

export {
  useGetInterestOptions
};
//# sourceMappingURL=chunk-V4UF3YL6.mjs.map